import React from "react";
import { List } from "../modules/Settings/Tags";

export function TagsListPage() {
  return <List />;
}
